import { productRefillMetafields } from '~/lib/shopify/constants/metafields'
import {
  getProductsFromShopify,
  getRefillFromShopify,
} from '~/lib/shopify/products'
import { metafieldsToObject } from '~/lib/shopify/utils/metafield-to-object'

import { GID } from '@unlikelystudio/commerce-connector'

import {
  ByCharlotProduct,
  serializeShopifyStorefrontData,
} from '~/data/product-card-data'

export async function serializeByCharlotPackProducts(tabsIds: GID[][], locale) {
  const idsToFetch = tabsIds?.flat()
  const packTabsProducts = (
    (await getProductsFromShopify({
      locale,
      ids:
        idsToFetch?.filter((item, pos) => idsToFetch.indexOf(item) == pos) ??
        [],
    })) ?? []
  )?.filter(Boolean)

  const packTabProducts = await Promise.all(
    tabsIds
      .map(
        async (tab) =>
          await Promise.all(
            tab.map(async (id) => {
              const product = packTabsProducts.find(
                (product) => product.id === id,
              )

              if (!product) return null
              const serializedStorefrontData =
                await serializeShopifyStorefrontData(product, locale, true)

              const refillMetafield = metafieldsToObject(
                product.metafields,
                productRefillMetafields,
              )
              // When a pack product is a customizable plant, we need to display its refill product image in the selector
              const refillImage = refillMetafield.refillProduct
                ? (
                    await getRefillFromShopify({
                      id: refillMetafield.refillProduct,
                      locale,
                    })
                  )?.featuredImage?.url
                : null
              const tabProduct: ByCharlotProduct = {
                ...product,
                ...serializedStorefrontData,
                ...(refillImage ? { featuredImage: refillImage } : {}),
                //@TODO reimplement satisfies once upgraded to next 13.x
              } // satisfies ByCharlotProduct

              return tabProduct
            }),
          ),
      )
      .filter(Boolean),
  )

  return packTabProducts
}
